<template>
  <b-row class="leave-row">
    <b-badge pill variant="outline-info" class="large badge-item">
      <template v-if="getCurrentLeave(user)">
        <template v-if="getCurrentLeave(user).daysLeft == 0">
          On Leave until tomorrow
        </template>
        <template v-else>
          On Leave until {{ getCurrentLeave(user).until }}
        </template>
      </template>
      <template v-else-if="getFutureLeave(user)">
        On leave
        {{
          `${
            getFutureLeave(user).daysUntil == 0
              ? "from tomorrow"
              : `in ${getFutureLeave(user).daysUntil} day${
                  getFutureLeave(user).daysUntil > 1 ? "s" : ""
                }`
          }`
        }}
      </template>
    </b-badge>
  </b-row>
</template>

<script>
export default {
  name: "LeaveRow",
  props: {
    user: {
      required: true,
      type: Object
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  methods: {
    /**
     * Gets current leave for user
     * @param user
     * @returns {null|{[p: string]: *}}
     */
    getCurrentLeave(user) {
      const currentLeave = user.upcomingLeave?.find(x =>
        this.$moment(x.from).isSameOrBefore(this.$moment(), "day")
      )
      if (!currentLeave) return null
      return {
        ...currentLeave,
        to: this.$moment(currentLeave.to).format("YYYY/MM/DD"),
        from: this.$moment(currentLeave.from).format("YYYY/MM/DD"),
        until: this.$moment(currentLeave.to)
          .add("days", "1")
          .format("YYYY/MM/DD"),
        daysLeft: this.$moment(currentLeave.from).diff(
          this.$moment(currentLeave.to),
          "days"
        )
      }
    },
    /**
     * Gets future leave for user - 1 week
     * @param user
     * @returns {null|{[p: string]: *}}
     */
    getFutureLeave(user) {
      const futureLeave = user.upcomingLeave?.find(x =>
        this.$moment(x.from).isSameOrBefore(
          this.$moment().add("days", "7"),
          "days"
        )
      )
      if (!futureLeave) return null
      return {
        ...futureLeave,
        daysUntil: this.$moment(futureLeave.from).diff(this.$moment(), "days")
      }
    }
  }
}
</script>

<style scoped>
.leave-row {
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.badge-item {
  margin: auto !important;
}
</style>
